import { motion } from "framer-motion";
import { DateTimeSelector } from "./DateTimeSelector";
import Icon from "@hudson/ui/components/Icon";
import useContent from "@lib/use_content";
import useWindowSize from "@utils/use_window_size";
import { isMobile } from "@hudson/ui/lib/utils";
import useConfig from "@lib/use_config";

function PickupOrFlightDateTimeSelector({
  className,
  disabled,
  fieldName,
  flightType,
  hideIcon,
  hideTime,
  isFlight,
  timeDefault,
}: {
  className?: string;
  disabled?: boolean;
  fieldName: string;
  flightType?: "arrival" | "departure";
  hideIcon?: boolean;
  hideTime?: boolean;
  isFlight: boolean;
  timeDefault?: string;
}): JSX.Element | null {
  useWindowSize(); // Rerenders the component on window size change.
  const { loading: cfgLoading, data: cfgData } = useConfig(["dateFormat", "timeFormat"]);
  const { data } = useContent([
    "bePickupDateLabel",
    "bePickupTimeLabel",
    "beFlightDateLabel",
    "beFlightDateArrLabel",
    "beFlightDateDepLabel",
    "beFlightTimeLabel",
    "beFlightTimeArrLabel",
    "beFlightTimeDepLabel",
  ]);

  const variants = {
    flight: {
      x: 0,
    },
    pickup: {
      x: 0,
    },
  };

  const iconVariants = {
    flight: {
      opacity: 1,
      display: "block",
    },
    pickup: {
      opacity: 0,
      display: "none",
    },
  };

  // Determine labels.
  let timeLabel = data?.content.bePickupTimeLabel,
    dateLabel = data?.content.bePickupDateLabel;
  if (isFlight && data?.content) {
    if (flightType === "arrival") {
      dateLabel = data.content.beFlightDateArrLabel || data.content.beFlightDateLabel;
      timeLabel = data.content.beFlightTimeArrLabel || data.content.beFlightTimeLabel;
    } else if (flightType === "departure") {
      dateLabel = data.content.beFlightDateDepLabel || data.content.beFlightDateLabel;
      timeLabel = data.content.beFlightTimeDepLabel || data.content.beFlightTimeLabel;
    }
  }

  return (
    <motion.div
      variants={variants}
      className={`inline-flex relative z-10 ${className}`}
      initial="pickup"
      animate={isFlight ? "flight" : "pickup"}
    >
      {!hideIcon && !isMobile(600) && (
        <motion.div variants={iconVariants}>
          <Icon type="plane" muted className="h-7 mr-4 ml-2 mt-2" />
        </motion.div>
      )}

      <DateTimeSelector
        fieldName={fieldName}
        dateFormat={cfgData?.config.dateFormat}
        dateLabel={dateLabel}
        disabled={disabled}
        hideTime={hideTime}
        loading={cfgLoading}
        timeDefault={timeDefault}
        timeFormat={cfgData?.config.timeFormat}
        timeLabel={timeLabel}
      />
    </motion.div>
  );
}

export default PickupOrFlightDateTimeSelector;
